<div class="no-results">
  @switch (error?.code) {
    @case (4122) {
      <ng-container *ngTemplateOutlet="noFindNationalDollar"></ng-container>
    }
    @case (4121) {
      <ng-container *ngTemplateOutlet="noFindNationalDollar"></ng-container>
    }
    @case (4123) {
      <div class="title">
        <p>No tenemos alojamientos en dólares</p>
      </div>
      <div class="subtitle">
        <p>Probá cambiando el tipo de moneda a $ Pesos Argentinos</p>
      </div>
      <div class="facture-no-almundo">
        <div class="svg-facture"></div>
      </div>
      <ng-container *ngTemplateOutlet="button_redirect"></ng-container>
    }
    @default {
      <span i18n="@@availability__no-dispo">No encontramos hoteles para tu destino.</span>
      @if (!error) {
        @if (!appliedFilters) {
          <span i18n="@@availability__try-again">Intentá nuevamente cambiando las opciones de búsqueda.</span>
        }
        @if (appliedFilters) {
          <span i18n="@@availability__try-again__without-filters">Intentá cambiar o borrar los filtros.</span>
        }
      } @else {
        <span>{{ message }}</span>
        @if (showError && error.stack_trace) {
          <span>{{ error.stack_trace }}</span>
        }
      }
      <div class="image" [ngClass]="brandImage"></div>
    }
  }
</div>

<ng-template #button_redirect>
  <div class="button-redirect">
    <button mb-button variant="outline" color="primary" (click)="redirect()">
      Buscar en $ pesos
    </button>
  </div>
</ng-template>

<ng-template #noFindNationalDollar>
  <div class="title">
    <p>No tenemos alojamientos nacionales en dólares</p>
  </div>
  <div class="subtitle">
    <p>Probá cambiando el tipo de moneda a $ Pesos Argentinos</p>
  </div>
  <div class="facture">
    <div class="svg-facture"></div>
  </div>
  <ng-container *ngTemplateOutlet="button_redirect"></ng-container>
</ng-template>